import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation SendCreditToUser($senderId: String!, $receiverId: String!, $amount: Float!, $currency: String!) {
    sendCreditToUser(senderId: $senderId, receiverId: $receiverId, amount: $amount, currency: $currency)
  }
`

export const toString = mutation.loc.source.body

export default mutation
